export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20gradient%20background%20with%20flowing%20dark%20red%20and%20deep%20crimson%20waves%2C%20soft%20golden%20light%20streaks%2C%20luxurious%20film%20texture%2C%20elegant%20movie%20theater%20atmosphere%2C%20no%20text%2C%20smooth%20gradients%2C%20premium%20dark%20aesthetic&width=1920&height=1080&seq=rose-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-20">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-400"></div>
              <span className="text-sm text-accent-300 font-medium whitespace-nowrap">最新影视 · 每日更新</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-4">
              玫瑰视频
              <span className="block text-xl md:text-2xl lg:text-3xl font-normal text-background-200/90 mt-2">
                高清影视聚合平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-background-200/80 font-heading italic mb-6">
              —— 91视频 · 久久视频 · 91在线视频，全集免费看不缓冲
            </p>

            <div className="space-y-3 mb-8">
              <p className="text-sm md:text-base text-background-200/70 leading-relaxed max-w-xl mx-auto lg:mx-0">
                玫瑰视频聚合91视频网站、久久视频、91在线视频等全网热门影视资源，
                每日同步更新最新影视内容。从电视剧全集到电影大全，从热播榜单到冷门佳作——
                高清免费在线观看，不缓冲流畅播放，让每一次观影都成为享受。
              </p>
              <p className="text-sm md:text-base text-background-200/70 leading-relaxed max-w-xl mx-auto lg:mx-0">
                无论你是追剧达人还是电影爱好者，玫瑰视频都能满足你对高品质观影体验的追求。
                全平台自适应，无需下载，打开即看。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">30,000+</div>
                <div className="text-xs md:text-sm text-background-300/70 mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs md:text-sm text-background-300/70 mt-1">内容同步</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">秒开不卡</div>
                <div className="text-xs md:text-sm text-background-300/70 mt-1">流畅播放</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScroll(e, '#cards')}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-accent-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-colors"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#about"
                onClick={(e) => handleScroll(e, '#about')}
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-background-300/40 text-background-100 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden ring-1 ring-background-50/10">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20film%20poster%20collage%20with%20dramatic%20lighting%2C%20movie%20projector%20beam%20effect%2C%20classic%20film%20reels%20and%20clapperboard%20elements%2C%20rich%20crimson%20and%20gold%20tones%2C%20luxurious%20movie%20theater%20vibe%2C%20vintage%20hollywood%20meets%20modern%20aesthetic%2C%20no%20text%2C%20atmospheric&width=800&height=1000&seq=rose-hero-visual&orientation=portrait"
                  alt="玫瑰视频观影体验"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 w-24 h-24 md:w-28 md:h-28 rounded-2xl overflow-hidden ring-2 ring-accent-500/40">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20of%20vintage%20film%20projector%20lens%20with%20warm%20glowing%20light%2C%20cinematic%20texture%2C%20golden%20and%20amber%20tones%2C%20nostalgic%20movie%20theater%20detail%2C%20shallow%20depth%20of%20field&width=280&height=280&seq=rose-hero-accent&orientation=squarish"
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#topics"
          onClick={(e) => handleScroll(e, '#topics')}
          className="flex flex-col items-center gap-1 text-background-300/60 hover:text-background-100 transition-colors cursor-pointer"
        >
          <span className="text-xs whitespace-nowrap">向下探索</span>
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-s-line text-lg"></i>
          </div>
        </a>
      </div>
    </section>
  );
}